import { DB_FORM_CACHE_NAME, formIndexedDBSchema } from './FormIndexedDBUtils';
import { DB_WHITEPAPERREPORT_NAME, whitePaperIndexedDBSchema } from './WhitePaperIndexedDBUtils';

interface DBSchemaRegistry {
    [key: string]: (db: IDBDatabase, storeName: string) => void;
}

// bump this whenever you change the schemas, or if you want to force clients to reload the indexedDb.
// this will trigger the onupgradeneeded event in the IndexedDB API.
// this includes situations where you add or remove object stores,
// because those can only be done in an upgrade transaction.
export const DB_VERSION = 4;

// All schemas for the IndexedDB
const DB_SCHEMA_REGISTRY: DBSchemaRegistry = {
    [DB_FORM_CACHE_NAME]: formIndexedDBSchema,
    [DB_WHITEPAPERREPORT_NAME]: whitePaperIndexedDBSchema,
};

export const getSchemaForDatabase = (databaseName: string): ((db: IDBDatabase, storeName: string) => void) => {
    const schemaFunction = DB_SCHEMA_REGISTRY[databaseName];

    if (!schemaFunction) {
        throw new Error(`Schema not found for database: "${databaseName}".`);
    }

    return schemaFunction;
};
